if (!customElements.get('kindra-mobile-navigation')) {
  customElements.define('kindra-mobile-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.animations = new Map();
      const { signal } = this.controller;
      this.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', String(details.open));
        summary.addEventListener('click', event => {
          event.preventDefault();
          this.toggleGroup(details, summary.getAttribute('aria-expanded') !== 'true');
        }, { signal });
      });
      const desktop = matchMedia('(min-width: 1150px)');
      desktop.addEventListener('change', event => {
        if (event.matches) this.closest('x-drawer')?.hide();
      }, { signal });
    }

    disconnectedCallback() {
      this.controller.abort();
      this.animations.forEach((animation, details) => {
        animation.cancel();
        this.finishGroup(details, details.querySelector('summary').getAttribute('aria-expanded') === 'true');
      });
      this.animations.clear();
    }

    finishGroup(details, expanded) {
      details.open = expanded;
      details.style.height = '';
      details.style.overflow = '';
      details.lastElementChild.inert = !expanded;
    }

    toggleGroup(details, expanded) {
      if (expanded) {
        this.querySelectorAll('details').forEach(other => {
          if (other !== details && other.querySelector('summary').getAttribute('aria-expanded') === 'true') {
            this.toggleGroup(other, false);
          }
        });
      }
      const startHeight = details.getBoundingClientRect().height;
      this.animations.get(details)?.cancel();
      this.animations.delete(details);
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', String(expanded));
      details.open = true;
      details.lastElementChild.inert = !expanded;
      details.style.height = '';
      const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
        this.finishGroup(details, expanded);
        return;
      }
      details.style.overflow = 'hidden';
      const animation = details.animate({ height: [startHeight + 'px', endHeight + 'px'] }, {
        duration: 550,
        easing: 'cubic-bezier(.45, 0, .25, 1)'
      });
      this.animations.set(details, animation);
      animation.finished.then(() => {
        if (this.animations.get(details) !== animation) return;
        this.animations.delete(details);
        this.finishGroup(details, expanded);
      }).catch(() => {});
    }
  });
}
